export function checkRes(data) {
    if (data.code > 0) {
        console.error(data.message);
        return false;
    } else {
        console.log(data);
        return true;

    }

}

export function handleError(error) {
    console.log(error)
    try {
        if (error.response.status == 500) {
            return 'internalError';

        } else if (error.response.status == 401) {
            localStorage.removeItem("aibotToken");
            setTimeout(() => {
                var current = location.origin + '/';
                window.location.href = current;

            }, 2000);
            return 'unauthorized';

        } else {
            localStorage.removeItem("aibotToken");
            setTimeout(() => {
                var current = location.origin + '/';
                window.location.href = current;

            }, 2000);
            return 'internalError';

        }

    } catch (error) {
        localStorage.removeItem("aibotToken");
        setTimeout(() => {
            var current = location.origin + '/';
            window.location.href = current;

        }, 2000);
        return 'unauthorized';

    }

}